import { BotConversation } from "../models/botConversation";
import { AxiosHttpClient } from "./AxiosHttpService";

export class ConversationService {
  static getConversations = () => {
    return AxiosHttpClient.get<BotConversation[]>(
      "api/v1/docuveritas/conversations"
    );
  };

  static deleteConversation = (conversationId: string) => {
    return AxiosHttpClient.delete<void>(
      "api/v1/docuveritas/conversations/" + conversationId
    );
  };
}
